import { render, staticRenderFns } from "./appointmentManageTC.vue?vue&type=template&id=2fc01e84&scoped=true"
import script from "./appointmentManageTC.vue?vue&type=script&lang=js"
export * from "./appointmentManageTC.vue?vue&type=script&lang=js"
import style0 from "./appointmentManageTC.vue?vue&type=style&index=0&id=2fc01e84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc01e84",
  null
  
)

export default component.exports